import { useState } from "react";
import { esSrc } from "@/lib/api";
import { ES_ARTWORK, artworkPath } from "@/blocks/esArtwork";
import { MediaPickerDialog } from "@/components/editor/MediaPicker";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ImagePlus, Check, Trash2, Upload } from "lucide-react";

export function ESArtworkField({ value, onChange, help }) {
  const [open, setOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  return (
    <div>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <div className="w-28 h-24 rounded-lg border border-[#E5E2D9] bg-[#111] flex items-center justify-center overflow-hidden">
              <img src={esSrc(value)} alt="" className="max-w-full max-h-full object-contain" />
            </div>
            <button type="button" onClick={() => onChange("")} data-testid="artwork-remove"
                    className="absolute -top-2 -left-2 bg-white border border-[#E5E2D9] rounded-full p-1.5 shadow-sm hover:bg-[#F7F5F0]">
              <Trash2 className="w-3.5 h-3.5 text-[#8C3A3A]" />
            </button>
          </div>
        ) : null}
        <button type="button" onClick={() => setOpen(true)} data-testid="artwork-choose"
                className="flex items-center gap-2 border-2 border-dashed border-[#E5E2D9] rounded-lg px-5 py-4 text-[#5C635C] hover:border-[#4A5D4E] hover:text-[#4A5D4E] transition-colors">
          <ImagePlus className="w-4 h-4" /> {value ? "החלפת יצירה" : "בחירת יצירה"}
        </button>
      </div>
      {help && <p className="text-xs text-[#8a8f89] mt-2">{help}</p>}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent dir="rtl" className="font-editor max-w-2xl" data-testid="artwork-dialog">
          <DialogHeader><DialogTitle className="text-right">בחירת יצירה מהספרייה</DialogTitle></DialogHeader>
          <button type="button" onClick={() => { setUploadOpen(true); }}
                  className="w-full mb-4 flex items-center justify-center gap-2 border-2 border-dashed border-[#E5E2D9] rounded-xl py-4 text-[#5C635C] hover:border-[#4A5D4E] hover:text-[#4A5D4E] transition-colors">
            <Upload className="w-4 h-4" /> העלאת תמונה משלך
          </button>
          <div className="grid grid-cols-4 gap-3 max-h-[55vh] overflow-y-auto">
            {ES_ARTWORK.map((a) => {
              const path = artworkPath(a.file);
              const active = value === path;
              return (
                <button key={a.file} type="button" onClick={() => { onChange(path); setOpen(false); }}
                        data-testid={`artwork-${a.file}`}
                        className={`group relative rounded-lg border p-2 bg-[#111] flex flex-col items-center gap-1 ${active ? "border-[#4A5D4E] ring-2 ring-[#4A5D4E]" : "border-[#E5E2D9] hover:border-[#4A5D4E]"}`}>
                  <div className="h-16 flex items-center justify-center">
                    <img src={path} alt={a.label} className="max-h-16 max-w-full object-contain" />
                  </div>
                  <span className="text-[10px] text-[#c8c4b8] truncate w-full text-center">{a.label}</span>
                  {active && <Check className="w-4 h-4 text-[#4A5D4E] absolute top-1 left-1" />}
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>

      <MediaPickerDialog open={uploadOpen} onOpenChange={setUploadOpen}
        onSelect={(url) => { onChange(url); setUploadOpen(false); setOpen(false); }} />
    </div>
  );
}
